module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTABS1wBS2QBQ1wBR2gBS2QBQ2QBS2wBS2er0iQQAAAAIdFJOUwCA7yCP31B/UMzbmQAAAENJREFUCNdj6IAABgYEgwEEQAwOIL8BhYEk1cDAwAZlFKlApFg6OgTADKZmCwVUBmNHhwPYigCYXQ2NEgwQIMDIAAcAzJsg1sgHKXsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imag2.png
// module id = bXLx
// module chunks = 1